import React, { useEffect, useState, useCallback } from 'react';
import './moderationMessages.css';
import ModeratePost from '../../components/moderatePost/ModeratePost';
import { API, graphqlOperation } from 'aws-amplify';
import { listMessagesModeration } from './queries';

export default function ModerationMessages({ role }) {
  const [posts, setPosts] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Track if more posts are available

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async (token = null) => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    try {
      const filter = { needsModeration: { eq: true } };
      console.log("Fetching posts with nextToken:", token);

      const postData = await API.graphql(
        graphqlOperation(listMessagesModeration, { filter, nextToken: token })
      );

      const newItems = postData.data.listMessages?.items || [];
      const newNextToken = postData.data.listMessages?.nextToken || null;

      setPosts(prevPosts => (token ? [...prevPosts, ...newItems] : newItems));
      setNextToken(newNextToken);
      setHasMore(!!newNextToken); // Set to false if newNextToken is null
    } catch (error) {
      console.error('Error fetching posts', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = useCallback(() => {
    if (isLoading || !nextToken) return;

    if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 10) {
      fetchPosts(nextToken);
    }
  }, [isLoading, nextToken]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const removePost = (postId) => {
    setPosts(prevPosts => prevPosts.filter(post => post.id !== postId));
  };

  return (
    <div className='feed'>
      <div className="feedWrapper">
        {posts.length > 0 ? (
          posts.map((p) => <ModeratePost key={p.id} post={p} removePost={removePost} />)
        ) : (
          <p>No posts due for moderation!</p>
        )}
        {isLoading && <p>Loading more posts...</p>}
      </div>
    </div>
  );
}
